<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="`conditionsRequirements.${dayOfWeekField}`"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeDayOfWeekField] ? 'Exclude' : 'Include')} ${$_.startCase(dayOfWeekField)}`"
      value-type="[Number]"
      :options="[
        { label: 'Monday', value: 1 },
        { label: 'Tuesday', value: 2 },
        { label: 'Wednesday', value: 3 },
        { label: 'Thursday', value: 4 },
        { label: 'Friday', value: 5 },
        { label: 'Saturday', value: 6 },
        { label: 'Sunday', value: 0 }
      ]"
      map-options
      emit-value
      multiple
      use-chips
      :rules="[val => !$_.isEmpty(val) || 'Field is required']"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeDayOfWeekField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'DayOfWeekConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    dayOfWeekField: {
      type: String,
      default: CONDITION_REQUIREMENTS.DAY_OF_WEEK
    },
    excludeDayOfWeekField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_DAY_OF_WEEK
    }
  }
}

</script>
